/* global document */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { Spin } from 'antd';

import configureStore from './redux/store';
import 'src/styles/global.scss';
import * as serviceWorker from 'src/serviceWorker';
import Routes from './routes/routes';
// Components

// HIJACK CONSOLE AND ERROR LOG FOR PRODUCTION
if (process.env.NODE_ENV !== 'development')
  window.console = {
    log: () => {},
    error: () => {},
    warn: () => {}
  }; //HIJACK CONSOLE LOG

const { persistor, store, history } = configureStore();
// persistor.purge(); // Debug to clear persist

const rootElement = document.getElementById('root');
console.log(process.env.REACT_APP_GLOBAL_SERVER);
const Root = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      {/* <I18n /> */}
      <Routes history={history} />
    </PersistGate>
  </Provider>
);

if (window.cordova) {
  document.addEventListener(
    'deviceready',
    () => {
      render(<Root />, rootElement);
      serviceWorker.register();
    },
    false
  );
} else {
  render(<Root />, rootElement);
  serviceWorker.register();
}
